import { Auth, getCookie } from "@/lib/cookie";
import { localization } from "@/lib/mapper";
import qs from "qs";

export class NoticeClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/notices`;
  }

  // eslint-disable-next-line class-methods-use-this
  get token() {
    return getCookie(Auth.AccessToken);
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async get(id, language) {
    const headers =
      this.language === localization.TH
        ? { Authorization: `Bearer ${this.token}` }
        : {
          Authorization: `Bearer ${this.token}`,
          "x-accept-language": language
        };

    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url, { headers });

    return response;
  }

  async post(data) {
    const url = `${this.baseURL}`;

    const response = await this.httpClient.request("post", url, {
      data
    });

    return response;
  }

  async put(id, data) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("put", url, {
      data
    });

    return response;
  }

  async putLanguage(id, data, language) {
    const headers =
      this.language === localization.TH
        ? { Authorization: `Bearer ${this.token}` }
        : {
          Authorization: `Bearer ${this.token}`,
          "x-accept-language": language
        };

    const url = `${this.baseURL}/${id}/translation`;

    const response = await this.httpClient.request("put", url, {
      headers,
      data
    });

    return response;
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }
}
